export const ECOREBATES_ENDPOINT_URL = 'https://thd.ecorebates.com/api/search/thd/productRebateDetails.json';

export const DEFAULT_PAGE_SIZE = 10;

export const EMPTY_FILTER_DATA = Object.freeze({
  appliedFilters: {},
  searchedItem: ''
});